import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Auth } from 'firebase/auth';
import { first, from, map, Observable } from 'rxjs';
import { AuthService } from '../auth.service';

export const EmailVerificationGuard: CanActivateFn = (
  route,
  state,
): Observable<boolean | UrlTree> => {
  const auth: Auth = inject(AuthService).auth();
  const router: Router = inject(Router);

  return from(auth.authStateReady()).pipe(
    first(),
    map(() => {
      const user = auth.currentUser;

      if (user && !user.emailVerified) {
        // Redirect to the email verification page with a redirectURL param
        const redirectURL =
          state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;

        return router.parseUrl(`confirmation-required?${redirectURL}`);
      }

      // Allow the access
      return true;
    }),
  );
};
